<template>
  <v-container class="mt-2">
    <v-card
      class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Modelo de Coparticipação - Detalhar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="remove">
            <v-icon small title="Remover">fas fa-trash</v-icon>
          </v-btn>
          <v-btn class="mx-1" small @click="edit">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn small @click="goBack">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader
        v-if="!shareModel"
        type="article, actions"
      ></v-skeleton-loader>

      <v-row v-if="shareModel">
        <v-col cols="5">
          <strong>Ordem</strong>
          {{shareModel.code}}
        </v-col>
        <v-col cols="7">
          <strong>Descrição</strong>
          {{shareModel.description}}
        </v-col>
      </v-row>
      <v-row v-if="shareModel">
        <v-col cols="5">
          <v-checkbox
              dense
              label="Ativo"
              v-model="shareModel.active"
              :true-value="true"
              :false-value="false"
              outlined
              :readonly="true"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-2 mb-2"></v-divider>

      <v-container
        fluid>
        <v-row justify="center">
          <v-expansion-panels accordion>
            <v-expansion-panel @click="toggleCarriersActions">
              <v-expansion-panel-header>
                <v-row class="mr-2">
                  <v-col cols="9">Operadora</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showCarriersActions"
                  >
                    <v-btn small @click.native.stop="$refs.carrierSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn class="mr-1" small @click.native.stop="$refs.carriers.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <share-model-carrier
                  ref="carriers"
                  :share-model-id="id"
                ></share-model-carrier>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <carrier-search
              ref="carrierSearch"
              :share-model-id="id"
              @selected="addAccount"
            ></carrier-search>
          </v-expansion-panels>
          <v-expansion-panels>
            <v-expansion-panel @click="togglePlansActions">
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Plano Operadora</v-col>
                  <v-col
                    cols="3"
                    class="d-flex justify-end"
                    v-if="showPlansActions"
                  >
                    <v-btn small @click.native.stop="$refs.productSearch.show">
                      <v-icon small title="Adicionar">fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn class="mr-1" small @click.native.stop="$refs.plans.removeAll">
                      <v-icon small title="Remover">fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <share-model-product
                  ref="plans"
                  :share-model-id="id"
                ></share-model-product>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search
              ref="productSearch"
              :share-model-id="id"
              @selected="addProduct"
            ></product-search>
          </v-expansion-panels>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row  class="mr-2">
                  <v-col cols="9">Informações do Registro</v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row v-if="shareModelRevision">
                  <v-col cols="6">
                    <strong>Usuário de criação:</strong> {{shareModelRevision.createdBy}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Usuário da última alteração:</strong> {{shareModelRevision.createdBy}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data de criação:</strong> {{$util.formatDateToBR(shareModelRevision.createdAt)}}
                  </v-col>
                  <v-col cols="6">
                    <strong>Data da última alteração:</strong> {{$util.formatDateToBR(shareModelRevision.updatedAt)}}
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <product-search
              ref="productSearch"
              :share-model-id="id"
              @selected="addProduct"
            ></product-search>
          </v-expansion-panels>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ShareModelProduct from "@/view/share_model/share_model_products";
import ShareModelCarrier from "@/view/share_model/share_model_carriers";
import ProductSearch from "@/view/share_model/share_model_product_search";
import CarrierSearch from "@/view/share_model/share_model_carrier_search";
import ShareModelPlanService from "@/services/insurancepricing/ShareModelPlanService";
import ShareModelCarrierService from "@/services/insurancepricing/ShareModelCarrierService";

export default {
  components: { ShareModelProduct, ProductSearch, CarrierSearch, ShareModelCarrier },
  data() {
    return {
      id: this.$route.params.id,
      shareModel: null,
      isLoading: false,
      shareModelPlans: [],
      showPlansActions: false,
      showCarriersActions: false,
    };
  },
  async created() {
    this._shareModelPlanService = new ShareModelPlanService();
    this._shareModelCarrierService = new ShareModelCarrierService();
    this.CLEAR_SHARE_MODEL_DESCRIPTIONS();
    this.fetchShareModel(this.id)
        .then((data) => {
          this.shareModel = data
        })
        .finally(() => {
          this.isLoading = false;
        });
    this.fetchShareModelRevision(this.id)
  },
  computed: {
    ...mapGetters("shareModel", ["shareModelProcessed", "getShareModel", "shareModelRevision"]),
  },
  methods: {
    ...mapActions("shareModel", ["deleteShareModel", "fetchShareModel", "fetchShareModelRevision"]),
    ...mapMutations(["toogleDialogLoading", 'showmsg']),
    ...mapMutations('shareModel', ['CLEAR_SHARE_MODEL_DESCRIPTIONS']),
    edit() {
      this.$router.push(`/share_model/${this.id}/edit`);
    },
    async remove() {
      this.toogleDialogLoading(true);
      await this.deleteShareModel(this.id);
      this.goBack();
      this.toogleDialogLoading(false);
    },
    togglePlansActions() {
      this.$refs.productSearch.resetData();
      this.showPlansActions = !this.showPlansActions;
    },
    toggleCarriersActions() {
      this.showCarriersActions = !this.showCarriersActions;
    },
    async addProduct(products) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      products.forEach((product) => bodyFormData.append('planIds', product.id))
      try {
        await this._shareModelPlanService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Planos associados com sucesso'});
        await this.$refs.plans.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },
    async addAccount(carriers) {
      this.toogleDialogLoading(true);
      const bodyFormData = new FormData();
      carriers.forEach((carrier) => bodyFormData.append('carrierIds', carrier.id))
      try {
        await this._shareModelCarrierService.save(this.id,  bodyFormData)
        this.showmsg({text: 'Operadoras associadas com sucesso'});
        await this.$refs.carriers.loadData();
      } catch (e) {
        console.log(e)
      }
      this.toogleDialogLoading(false);
    },    
    goBack() {
      this.$router.push(`/share_model`);
    },
  },
};
</script>
